import gql from 'graphql-tag'

export const startBankIdSession = gql`
  mutation DooerComSignup($input: SignupInput!, $sePersonnummer: SwedishPersonalIdentificationNumber) {
    signupWithBankId(input: $input, sePersonnummer: $sePersonnummer) {
      id
      autoStartToken
      bankIdQRImage
      status
      hintCode
      token
    }
  }
`

export const getBankidSession = gql`
  query DooerComGetBankIdSessionV2($id: ID!) {
    bankIdSessionV2(id: $id) {
      id
      autoStartToken
      bankIdQRImage
      status
      hintCode
      token
    }
  }
`
